import { request } from '@/utils/request'
const StationManageService = {
  state: {},

  mutations: {},

  actions: {
    // 项目分项管理列表
    getItemizedmanagement({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('Assets/AssetsSubentrySection/GetAssetsSubentrySectionListJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 保存岗位管理数据
    saveItemizedmanagement({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Assets/AssetsSubentrySection/SubmitForm?keyValue=' + params.keyValue, params.formData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除设备属性
    DeleteItemizedmanagement({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('Assets/AssetsSubentrySection/DeleteForm', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取单位列表数据
    GetAttributetype({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/ItemsData/GetSelectJson', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default StationManageService
